module.exports = {
	"contract_name": "BitEtherCoin",
	"abi": [
		{
			"constant": false,
			"inputs": [],
			"name": "getEra",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				},
				{
					"name": "",
					"type": "uint256"
				},
				{
					"name": "",
					"type": "uint256"
				},
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "name",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_spender",
					"type": "address"
				},
				{
					"name": "_value",
					"type": "uint256"
				}
			],
			"name": "approve",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "totalSupply",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_from",
					"type": "address"
				},
				{
					"name": "_to",
					"type": "address"
				},
				{
					"name": "_value",
					"type": "uint256"
				}
			],
			"name": "transferFrom",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_eraBlock",
					"type": "uint256"
				},
				{
					"name": "_blockMined",
					"type": "uint256"
				},
				{
					"name": "_blockNumber",
					"type": "uint256"
				},
				{
					"name": "_rewardPrev",
					"type": "uint256"
				},
				{
					"name": "_reward",
					"type": "uint256"
				}
			],
			"name": "getUnclaimed",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "decimals",
			"outputs": [
				{
					"name": "",
					"type": "uint8"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_block",
					"type": "uint256"
				}
			],
			"name": "getEraForBlock",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				},
				{
					"name": "",
					"type": "uint256"
				},
				{
					"name": "",
					"type": "uint256"
				},
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "claim",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_owner",
					"type": "address"
				}
			],
			"name": "balanceOf",
			"outputs": [
				{
					"name": "balance",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "symbol",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_to",
					"type": "address"
				},
				{
					"name": "_value",
					"type": "uint256"
				}
			],
			"name": "transfer",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_owner",
					"type": "address"
				},
				{
					"name": "_spender",
					"type": "address"
				}
			],
			"name": "allowance",
			"outputs": [
				{
					"name": "remaining",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"inputs": [],
			"payable": false,
			"type": "constructor"
		},
		{
			"payable": false,
			"type": "fallback"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "_from",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "_to",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "_value",
					"type": "uint256"
				}
			],
			"name": "Transfer",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "_owner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "_spender",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "_value",
					"type": "uint256"
				}
			],
			"name": "Approval",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "_miner",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "_value",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "_current",
					"type": "bool"
				}
			],
			"name": "Reward",
			"type": "event"
		}
	],
	"unlinked_binary": "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",
	"networks": {},
	"schema_version": "0.0.5",
	"updated_at": 1489690817293
};


//////////////////
// WEBPACK FOOTER
// ./src/contracts/BitEtherCoin.json
// module id = 189
// module chunks = 0